import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/login")({
  beforeLoad: async ({ context }) => {
    await context.auth.signinRedirect();
  },
});
